import TopHeader from "components/top/TopHeader";
import React from "react";
import { Helmet } from "react-helmet-async";
const ErrorAuth: React.FC = () => {
  return (
    <div className="w-full">
      <Helmet>
        <title>エラー</title>
      </Helmet>
      <TopHeader />

      <div className="flex justify-center py-24">
        <div className="text-2xl font-bold text-center">
          <p className="mb-24">ログインが無効になりました。再度ログインしてください。</p>
          <a target="_blank" className="text-base text-jhk-blue" href={process.env.REACT_APP_TOPPAGE_JDP_STG_URL} rel="noreferrer">
            {process.env.REACT_APP_TOPPAGE_JDP_STG_URL}
          </a>
        </div>
      </div>
    </div>
  );
};
export default ErrorAuth;
